import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
 // eslint-disable-next-line
import './cookies.js'

createApp(App).use(router).mount('#app')